import { render, staticRenderFns } from "./trainingSafeInfo.vue?vue&type=template&id=36c38b6c&scoped=true"
import script from "./trainingSafeInfo.vue?vue&type=script&lang=js"
export * from "./trainingSafeInfo.vue?vue&type=script&lang=js"
import style0 from "./trainingSafeInfo.vue?vue&type=style&index=0&id=36c38b6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c38b6c",
  null
  
)

export default component.exports